import { tv } from "tailwind-variants";

/**
 * Style
 */

const { bg, text } = tv({
  slots: {
    bg: "w-5 h-5 flex items-center justify-center rounded-[20px] cursor-pointer",
    text: "font-semibold text-[0.80rem]"
  },
  variants: {
    color: {
      red: {
        bg: "bg-red-500",
        text: "text-white"
      },
      blue: {
        bg: "bg-blue-500",
        text: "text-white"
      },
      yellow: {
        bg: "bg-yellow-400",
        text: "text-black"
      },
      green: {
        bg: "bg-primary-green",
        text: "text-white"
      },
      gray: {
        bg: "bg-gray-400/30",
        text: "text-black"
      },
    }
  }
})();

/**
 * LegendCircularIcon
 */

type Props = {
  color: 'red' | 'blue' | 'yellow' | 'green' | 'gray',
  title: string,
};

export const LegendCircularIcon = ({
  color,
  title,
}: Props) => {
  return (
    <div className={bg({ color })}>
      <h1
        className={text({ color })}
        style={{ color: 'white', textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000' }}>
        {title}
      </h1>
    </div>
  );
}